import {defineStore} from 'pinia'
import {ref} from 'vue'
import {createApi} from "@/services/api"
import Axios from "axios"

export const userStore = defineStore('user', () => {
    const userdata = ref({
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        photo: '',
        photo_thumb: '',
        cover: '',
        company: '',
        username: '',
        about: '',
        can_change_username: false,
        show_thesis: false,
        department: ''
    })

    const roles = ref([])

    const permissions = ref([])

    const profile_loaded = ref(false)

    function getData() {
        return userdata.value
    }

    function clear() {
        userdata.value = {
            id: '',
            first_name: '',
            last_name: '',
            email: '',
            photo: '',
            photo_thumb: '',
            cover: '',
            company: '',
            username: '',
            about: '',
            can_change_username: false,
            show_thesis: false,
            department: ''
        }
    }

    function setUser(data: any) {
        //console.log('some data',  data.department)
        userdata.value.id = data.id
        userdata.value.first_name = data.first_name
        userdata.value.last_name = data.last_name
        userdata.value.photo = data.profile ? data.profile.photo : ''
        userdata.value.photo_thumb = data.profile ? data.profile.photo_thumb : ''
        userdata.value.cover = data.profile ? data.profile.cover : ''
        userdata.value.email = data.email
        userdata.value.company = data.profile ? data.profile.company : ''
        userdata.value.username = data.profile ? data.profile.username : ''
        userdata.value.about = data.profile ? data.profile.about : ''
        userdata.value.show_thesis = data.show_thesis || false
        userdata.value.department = data.department ? data.department : ''
        profile_loaded.value = true

        setRoles(data.roles)
        setPermissions(data.permissions)
    }

    async function loadProfile() {
        const api = createApi({handler: Axios, namespace: '/v1'})
        return api.get('profile').then((response: any) => {
            setUser(response.data.data)
            return response.data.data
        }).catch((error: any) => {
            console.error('Failed to load profile from store:', error)
        })
    }

    function setProfilePhoto(photo: string, photo_thumb: string) {
        userdata.value.photo = photo
        userdata.value.photo_thumb = photo_thumb
    }

    function setCoverPhoto(photo: string) {
        userdata.value.cover = photo
    }

    function setPermissions(data: any) {
        permissions.value = data
    }

    function setRoles(data: any) {
        roles.value = data
    }

    return {
        userdata,
        roles,
        permissions,
        profile_loaded,
        getData,
        setUser,
        setProfilePhoto,
        setCoverPhoto,
        loadProfile,
        clear
    }
})

